<template>
  <div>
    <page-title :title="pageTitle" :helpLink="{ path: '/pages/station-collector-help', hash: 'AllergenCollectionSet_Import' }" />
    <b-row>
      <b-col>
        <b-card class="mt-3">
          <h4 slot="header">Station</h4>
          <select-control label="Station" v-model="stationId" :options="stations" required></select-control>
        </b-card>
      </b-col>
      <b-col>
        <b-card class="mt-3">
          <h4 slot="header">Help</h4>
          <content-block name="BulkUploadShort" />
        </b-card>
        <b-card class="mt-3" v-if="stationId">
          <h4 slot="header">Download Template</h4>
          <p>To bulk upload collection data, you must use a specific CSV file format. Click the "Get Template" button below to download this file.</p>
          <b-button @click="getCsvTemplate">Get Template</b-button>
        </b-card>
        <b-card class="mt-3" v-if="stationId">
          <h4 slot="header">Upload Bulk Data</h4>
          <p>Choose a CSV file (based on the template) to upload and then click the "Upload Bulk Data" button.</p>
          <p>
            <b-form-file accept=".csv" placeholder="Click the Browse button to choose a file" @change="onFileSelected"></b-form-file>
          </p>
          <b-button @click="importCsvData" :disabled="!file">Upload Bulk Data</b-button>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CrudOperationsMixin from '../Common/CrudOperationsMixin.js'

export default {
  name: "AllergenCollectionSetImport",
  mixins: [CrudOperationsMixin],
  props: [
  ],
  data() {
    return {
      stations: [],
      stationId: null,
      station: null,
      file: null
    }
  },
  computed: {
    pageTitle: function () {
      if (!this.station)
        return 'Bulk Upload Allergen Collection Sets';
      else
        return 'Bulk Upload Allergen Collection Sets: ' + this.station.displayCity + (this.station.state ? ', ' + this.station.state : '') + ' (' + this.station.name + ')';
    }
  },
  methods: {
    load: function () {
      this.readQuery('/graphql/management', {
        query: `
          query {
            stations (limit: 1000, order: "displayCity") {
              id,
              name,
              displayCity,
              state
            }
          }`,
        variables: { }
      }, (data) => {
        this.stations = data.stations.filter(s => s.displayCity).map(s =>  {
          return {
            value: s.id,
            text: s.displayCity + (s.state ? ', ' + s.state : '') + ': ' + s.name
          };
        });

        if (this.stations.length > 1)
          this.stations.unshift({
            value: null,
            text: ''
          });

        if (this.stations.length > 0)
          this.stationId = this.stations[0].value;
      });
    },
    onFileSelected: function (e) {
      if (e.target.files && e.target.files.length > 0)
        this.file = e.target.files[0];
    },
    importCsvData: function () {
      let reader = new FileReader();
      reader.onload = e => {
        if (e.target.readyState == FileReader.DONE) {
          this.query('/graphql/management', {
            query: `
              mutation ($stationId: ID!, $csvData: String!) {
                importCsvData(stationId: $stationId, csvData: $csvData)
              }`,
            variables: {
              'stationId': this.stationId,
              'csvData': e.target.result
            }}, () => {
              this.$router.push('/allergenCollectionSet');
            }, null, 'Collections Imported', 'Error Importing Collections', 'The collections were successfully imported.');
        }
      };
      reader.readAsText(this.file);
    },
    getCsvTemplate: function () {
      this.query('/graphql/management', {
        query: `
          query ($stationId: ID!) {
            getCsvTemplate(stationId: $stationId)
          }`,
        variables: {
          'stationId': this.stationId,
        }}, (data) => {
          //console.log(data);

          let w = window.open();
          let el = w.document.createElement('a');
          //let el = document.createElement('a');
          el.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(data.getCsvTemplate));
          el.setAttribute('download', 'NABTemplate.csv');

          el.style.display = 'none';

          w.document.body.appendChild(el);
          el.click();
          w.document.body.removeChild(el);

        }, null, null, null, null);
    }  
  },
  watch: {
    stationId: function (newValue, oldValue) {
      this.readQuery('/graphql/management', {
        query: `
          query ($id: ID) {
            station (id: $id) {
              id,
              city,
              state,
              displayCity,
              name,
            }
          }`,
        variables: {
          'id': newValue
        }
      }, (data) => {
        this.station = data.station;
      });
    }
  },
  mounted () {
    this.load();
  }
};
</script>